// ======================================================================
// File Name       : container
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as ActionTypes from '../constants/actionTypes/container';
import { STRUCTURE_TYPE } from '../constants';
import { COURSE_GROUP_RELATION_TYPE } from '../constants/CourseConstants';
import store from '../store';
import { hasProperty } from '../utils';

const INITIAL_STATE = {
  structures: {
    bySecernId: {
      // structureSecernId : structure
    },
    allSecernIds: [],
    courseSecernIds: [],
  },
  editingStructure: {},
  isInitiated: false,
  indirectOnCourseRelation: [],
  isAdminHasCourseRelation: false,
  // sprint_20230522_tma START
  structuresByItem: {
    bySecernId: {
    },
    allSecernIds: [],
    courseSecernIds: [],
  },
  selectedItemList: [],
  selectedItemRelationList: [],
  selectedItemSecernIdList: [],
  // sprint_20230522_tma END
};

export default function course(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ActionTypes.CONTAINER_RECEIVE_COURSE_STRUCTURE:
      return receiveCourseStructure(state, action);

    case ActionTypes.CONTAINER_INIT_DATA_FOR_EDIT_STRUCTURE:
      return initEditStructure(state, action);

    case ActionTypes.CONTAINER_UPDATE_DISPLAY_ORDER:
      return updateDisplayOrder(state, action);

    case ActionTypes.CONTAINER_REINIT_CONTAINER_TREE:
      return reInitContainerTree(state, action);

    case ActionTypes.CONTAINER_DESTROY_CONTAINER_TREE:
      return destroy();

    case ActionTypes.CONTAINER_INIT_CONTAINER_TREE: {
      const { isInitiated } = action;
      if (!isInitiated) {
        return {
          structures: {
            bySecernId: {},
            allSecernIds: [],
            courseSecernIds: [],
          },
          editingStructure: {},
          isInitiated,
          // sprint_20230522_tma START
          structuresByItem: {
            bySecernId: {},
            allSecernIds: [],
            courseSecernIds: [],
          },
          selectedItemList: [],
          selectedItemRelationList: [],
          selectedItemSecernIdList: [],
          // sprint_20230522_tma END
        };
      }
      return {
        ...state,
        isInitiated,
      };
    }
    // sprint_20230522_tma START
    case ActionTypes.CONTAINER_RECEIVE_COURSE_STRUCTURE_ITEM_TREE:
      return receiveItemTree(state, action);

    case ActionTypes.CONTAINER_SELECTED_ITEM_ON_DIALOG:
      return selectedItemOnDialog(state, action);

    case ActionTypes.CONTAINER_DEL_SELECTED_ITEM_ON_DIALOG:
      return removeItemListRelation(state, action);

    case ActionTypes.REMOVED_DATA_WITH_SELECTED_ITEM_LIST: {
      const { box, item } = store.getState();
      box.selectedItemList = [];
      item.selectedItemList = [];

      return {
        ...state,
        selectedItemList: [],
        selectedItemSecernIdList: [],
        structuresByItem: {
          bySecernId: {},
          allSecernIds: [],
          courseSecernIds: [],
        },
      };
    }

    case ActionTypes.CONTAINER_INIT_DATA_FOR_ITEM_TREE_DIALOG: {
      return initDataForItemTreeDialog(state, action);
    }
    // sprint_20230522_tma END
    default:
      return state;
  }
}

function reInitContainerTree(state, action) {
  const { structures } = action;
  const { bySecernId } = structures;
  Object.keys(bySecernId).reduce((acc, cur) => {
    bySecernId[cur].hasSubStructures = false;
    if (bySecernId[cur].parentBoxSecernId) {
      const parentBoxSecernId = bySecernId[cur].parentBoxSecernId;
      bySecernId[parentBoxSecernId].hasSubStructures = true;
    }
    if (bySecernId[cur].parentCourseSecernId) {
      const parentCourseSecernId = bySecernId[cur].parentCourseSecernId;
      bySecernId[parentCourseSecernId].hasSubStructures = true;
    }
    return acc;
  }, []);
  return {
    ...state,
    structures,
  };
}

function receiveCourseStructure(state, action) {
  const { structureList, userCourseRelation, groupCourseRelationList } = action;
  let newState = { ...state };
  if (structureList && structureList.length) {
    newState = structureList.reduce((acc, cur) => {
      const { structureSecernId } = cur;
      acc.structures.bySecernId[structureSecernId] = cur;
      acc.structures.allSecernIds.push(structureSecernId);

      if (cur.structureType === STRUCTURE_TYPE.COURSE){
        acc.structures.courseSecernIds.push(structureSecernId);
      } else if (cur.parentBoxSecernId) {
        const parentBox = acc.structures.bySecernId[cur.parentBoxSecernId];
        parentBox && (parentBox.hasSubStructures = true);
      } else if (cur.parentCourseSecernId) {
        const parentCourse = acc.structures.bySecernId[cur.parentCourseSecernId];
        parentCourse && (parentCourse.hasSubStructures = true);
      }

      return acc;
    }, newState);
  }
  const structuresTemp = { ...newState.structures };
  newState.structures = structuresTemp;
  newState.indirectOnCourseRelation = getIndirectGroupCourseRelation(groupCourseRelationList, userCourseRelation);
  if((userCourseRelation && Object.keys(userCourseRelation).length > 0) ||
      (groupCourseRelationList && groupCourseRelationList.length > 0)){
    newState.isAdminHasCourseRelation = true;
  } else {
    newState.isAdminHasCourseRelation = false;
  }
  
  return newState;
}

function getIndirectGroupCourseRelation(groupCourseRelationList, userCourseRelation) {
  const indirectOnCourseRelation = groupCourseRelationList
    .reduce((ids, curr) => {
      if(curr.courseGroupRelationType === COURSE_GROUP_RELATION_TYPE.INDIRECT &&
        !userCourseRelation[curr.courseSecernId]){
        ids.push(curr.courseSecernId);
      }
      return ids;
    }, []);
  return indirectOnCourseRelation;
}

function initEditStructure(state, action) {
  const { structureSecernId, structureSecernIdList, structureType } = action;
  const editingStructure = {
    ...state.structures.bySecernId[structureSecernId],
    structureSecernIdList,
    structureType,
  };
  return {
    ...state,
    editingStructure,
  };
}

function updateDisplayOrder(state, action) {
  const { structureSecernIdList } = action;
  const editingStructure = {
    ...state.editingStructure,
    structureSecernIdList,
  };
  return {
    ...state,
    editingStructure,
  };
}

function destroy() {
  return {
    structures: {
      bySecernId: {},
      allSecernIds: [],
      courseSecernIds: [],
    },
    editingStructure: {},
  };
}

// sprint_20230522_tma START
function receiveItemTree(state, action) {
  const { structureListItemTree } = action;
  const { structureList } = structureListItemTree;
  const { allSecernIds, bySecernId } = state.structures;
  let newState = { ...state };
  if (structureList && structureList.length) {
    newState = structureList.reduce((acc, cur) => {
      const { structureSecernId, rootCourseSecernId } = cur;
      acc.structuresByItem.bySecernId[structureSecernId] = cur;
      acc.structuresByItem.allSecernIds.push(structureSecernId);

      if (cur.structureType === STRUCTURE_TYPE.COURSE) {
        acc.structuresByItem.courseSecernIds.push(structureSecernId);
      } else if (cur.parentBoxSecernId) {
        const parentBox = acc.structuresByItem.bySecernId[cur.parentBoxSecernId];
        parentBox && (parentBox.hasSubStructures = true);
      } else if (cur.parentCourseSecernId) {
        const parentCourse = acc.structuresByItem.bySecernId[cur.parentCourseSecernId];
        parentCourse && (parentCourse.hasSubStructures = true);
        if (!acc.structuresByItem.courseSecernIds[rootCourseSecernId]) {
          acc.structuresByItem.courseSecernIds.push(rootCourseSecernId);
        }
      }
      //add record with course to bySecernId in structureListItemTree
      if (acc.structuresByItem.allSecernIds.indexOf(rootCourseSecernId) < 0) {
        acc.structuresByItem.allSecernIds.push(rootCourseSecernId);
      }
      if (!acc.structuresByItem.bySecernId[rootCourseSecernId]) {
        acc.structuresByItem.bySecernId[rootCourseSecernId] = bySecernId[rootCourseSecernId];
      }

      return acc;
    }, newState);
  }
  const structuresTemp = { ...newState.structuresByItem };
  newState.structuresByItem = structuresTemp;

  return newState;
}

function selectedItemOnDialog(state, action) {
  const selectedItemList = [...state.selectedItemList];
  const selectedItemRelationList = [...state.selectedItemRelationList];
  const selectedItemSecernIdList = [...state.selectedItemSecernIdList];
  const { selectedItemOnDialog } = action;
  const { bySecernId } = state.structures;

  // Collect selected itemSecernId in action
  const selectedIds = selectedItemList.reduce((ids, cur) => {
    ids.push(cur.itemSecernId);
    return ids;
  }, []);

  // Collect itemSecernId from detail.
  const selectedItemRelationIds = selectedItemRelationList.reduce((ids, curr) => {
    ids.push(curr.itemSecernId);
    return ids;
  }, []);

  // Step 10.2.0 START
  if (selectedItemOnDialog) {
    for (let i = 0; i < selectedItemOnDialog.length; i++) {
      //check item structure type is item
      const isItemSecernId = bySecernId[selectedItemOnDialog[i]].structureType === STRUCTURE_TYPE.ITEM;
      if (isItemSecernId && selectedIds.indexOf(selectedItemOnDialog[i]) === -1) {
        const newItemList = {
          itemSecernId: selectedItemOnDialog[i],
          addNew: true,
        };
        // Check exist in list item get from detail.
        if (selectedItemRelationIds.indexOf(selectedItemOnDialog[i]) !== -1) {
          newItemList.addNew = false;
        }
        selectedItemSecernIdList.push(selectedItemOnDialog[i]);
        selectedItemList.unshift(newItemList);
      }
    }
  }
  // Step 10.2.0 END
  return {
    ...state,
    selectedItemList,
    selectedItemSecernIdList,
  };
}

function removeItemListRelation(state, action) {
  const selectedItemList = [...state.selectedItemList];
  const selectedItemSecernIdList = [...state.selectedItemSecernIdList];
  const { box, item } = store.getState();
  const { index } = action;
  selectedItemList.splice(index, 1);
  selectedItemSecernIdList.splice(index, 1);

  if (box.selectedItemList && Object.keys(box.selectedItemList).length) {
    box.selectedItemList.splice(index, 1);
  }

  if (box.editingBox && Object.keys(box.editingBox).length &&
    box.editingBox.itemListForItemStart && box.editingBox.itemListForItemStart.length) {
    box.itemListForBoxStart.splice(0, 1);
  }

  if (item.selectedItemList && Object.keys(item.selectedItemList).length) {
    item.selectedItemList.splice(index, 1);
  }

  if (item.edittingItem && Object.keys(item.edittingItem).length &&
    item.itemListForItemStart && item.itemListForItemStart.length) {
    item.itemListForItemStart.splice(index, 1);
  }

  return {
    ...state,
    selectedItemList,
    selectedItemSecernIdList,
  };
}

function initDataForItemTreeDialog(state, action) {
  const { structureSecernId, structureType, isRegister } = action;

  const { box: { boxs }, item: { items } } = store.getState();
  const { structures } = state;

  let rootCourseSecernId;
  if (isRegister) {
    if (structures.bySecernId[structureSecernId].rootCourseSecernId) { // get roorCourseSecernId when regist box to course
      rootCourseSecernId = structures.bySecernId[structureSecernId].rootCourseSecernId;
    } else {// get roorCourseSecernId when regist box to box or regist item to box.
      rootCourseSecernId =
      boxs && boxs.bySecernId[structureSecernId] && boxs.bySecernId[structureSecernId].rootCourseSecernId;
    }
  } else {
    switch (structureType) {
      case STRUCTURE_TYPE.BOX: {
        rootCourseSecernId =
          boxs && boxs.bySecernId[structureSecernId] && boxs.bySecernId[structureSecernId].rootCourseSecernId;
        break;
      }
      case STRUCTURE_TYPE.ITEM: {
        rootCourseSecernId =
          items && items.bySecernId[structureSecernId] && items.bySecernId[structureSecernId].courseSecernId;
        break;
      }
      default:
        break;
    }
  }

  return {
    ...state,
    structureType,
    rootCourseSecernId,
  };
}
// sprint_20230522_tma END
